import { useCallback, useEffect, useState } from 'react';
import { ShippingMethod } from 'types/entity/cart';
import { Order } from 'types/entity/order';

type UseOrderInfoDataProps = {
  order?: Order;
  shippingMethods: ShippingMethod[];
};

const useOrderInfoData = ({ order, shippingMethods }: UseOrderInfoDataProps) => {
  const [orderNumber, setOrderNumber] = useState('');
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [shippingAddress, setShippingAddress] = useState('');

  const updateOrderNumber = useCallback(() => {
    const label = order?.orderNumber ?? '';
    setOrderNumber(label);
  }, [order?.orderNumber]);

  const updateDeliveryMethod = useCallback(() => {
    const shippingMethod = shippingMethods?.find(
      (method) => method.shippingMethodId === order?.shippingInfo?.shippingMethodId,
    ) as ShippingMethod;

    const shippingDate = new Date();

    shippingDate.setDate(shippingDate.getDate() + +(shippingMethod?.description ?? 0));

    const label = `${shippingDate.toISOString().split('T')[0]} with ${shippingMethod?.name ?? ''}`;

    setDeliveryMethod(label);
  }, [order?.shippingInfo?.shippingMethodId, shippingMethods]);

  const updateShippingAddress = useCallback(() => {
    if (order?.shippingAddress) {
      const { streetName, city, postalCode } = order.shippingAddress;
      const label = `${streetName}, ${city}, ${postalCode}`;
      setShippingAddress(label);
    }
  }, [order?.shippingAddress]);

  useEffect(() => {
    if (order) {
      updateOrderNumber();
      updateDeliveryMethod();
      updateShippingAddress();
    }
  }, [order, updateDeliveryMethod, updateOrderNumber, updateShippingAddress]);

  return {
    orderNumber,
    deliveryMethod,
    shippingAddress,
  };
};

export default useOrderInfoData;
